<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ detail__detail? 'DETAIL DU' : (Object.entries(this.data).length === 0 ? "NEW" : "CHANGE THE ") }} EXPRESSION</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0" />
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="px-6 py-2">
              <vs-alert :active="inputValid" color="danger" icon-pack="feather" icon="icon-info" >
                <span>This expression already exists, <b>please choose another expression.</b></span>
              </vs-alert>
              
                <p class="mt-5" >Name <b style="color: #ff6141">*</b> </p>
                <vs-input v-model="input.libelle" class="w-full" name="item-code" />
            </div>
        </VuePerfectScrollbar>
        <div v-if="!detail__detail" class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button class="mr-6" @click="findIfTheExpressionExists">Submit</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
let base_self = ''
const input_tempon = {
  libelle: ''
}

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  components: {VuePerfectScrollbar},
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      inputValid: false,
      initialNoError: {
        libelle: false,
        wording: false
      },
      error: {
        libelle: false,
        wording: false
      },
      all_errors: {
        libelle: [],
        wording: []
      },
      input: JSON.parse(JSON.stringify(input_tempon)),
      input1: JSON.parse(JSON.stringify(input_tempon)),
      detail__detail: false,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid () {
      let is_valide = true
      if (!this.input.libelle || this.input.libelle === '') is_valide = false
      return is_valide
    }
  },
  methods: {
    async findIfTheExpressionExists () {
      const data = {
        is_get: true,
        paginate: {
          length: 1,
          page: 1
        },
        filter: {
          state: true
        }
      }

      data['filter']['libelle__icontains'] = base_self.input.libelle
      /* const param = {
        simple: true,
        data: JSON.stringify(data),
        is_json: '0'
      } */

      const reponse = await base_self.$http.post(`${base_self.$store.state.route_for_account}expression`, data)

      if (reponse.data.data.length) {
        base_self.inputValid = true
      } else {
        base_self.inputValid = false
        base_self.createExpression()
      }
    },
    async createExpression () {
      const input = JSON.parse(JSON.stringify(this.input))
      
      base_self.$http.post(`${base_self.$store.state.route_for_account}expression`, input)
        .then((response) => { 
          console.log('response.data.data.id: ', response.data.data.id)
          window.getESM.success('The expression is added successfully.', response)
          base_self.submitDataAll(response.data.data.id)
          /* this.$emit('closeSidebar')
          this.initValues() */
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    async submitDataAll (id) {
      const libelle = base_self.input.libelle

      const traductions = [] // traduction
      const param = {}
      const reponse = await base_self.$http.get(`${base_self.$store.state.route_for_account}langue`, param)

      const length = reponse.data.data.length
      for (let i = 0; i < length; i++) {
        traductions.push({
          libelle,
          language: reponse.data.data[i].id,
          expression: id
        })
      }

      console.log(' ::::::::::::::::::::::::::::::::::::::::::::::::::::::traductions: ')
      console.log(' ::::::::::::::::::::::::::::::::::::::::::::::::::::::traductions: ')
      console.log(' ::::::::::::::::::::::::::::::::::::::::::::::::::::::traductions: ')
      console.log(' ::::::::::::::::::::::::::::::::::::::::::::::::::::::traductions: ')
      console.log('traductions: ', traductions)

      base_self.submitData(traductions)
    },
    async submitData (traductions) {
      base_self.$vs.loading()
      base_self.$http.post(`${base_self.$store.state.route_for_account}traduction`, { data: traductions, many: true })
        .then((response) => {
          base_self.$vs.loading.close()
          window.getESM.success('All translations is added successfully.', response)
          if (window.getAppTraductions.input.language) {
            window.getAppTraductions.getTraductions(window.getAppTraductions.input.language)
          }
          this.$emit('closeSidebar')
          this.initValues()
        })
        .catch((error) => {
          base_self.$vs.loading.close()
          console.log('error: ', error)
        })
    },
    initValues () {
      base_self.input = JSON.parse(JSON.stringify(input_tempon))
      base_self.input1 = JSON.parse(JSON.stringify(input_tempon))
      base_self.detail__detail = false
    }
  },
  watch: {
    /* input: {
      handler () {
        if (base_self.input1.libelle !== base_self.input.libelle) {
          base_self.initialNoError.libelle = true
          base_self.verification_libelle()
        }

        base_self.input1 = JSON.parse(JSON.stringify(base_self.input))
      },
      deep: true
    }, */
    async isSidebarActive () {
      this.initValues()
      if (base_self.data && base_self.data.id) {
        base_self.input = JSON.parse(JSON.stringify(base_self.data))
      }
    }
  },
  created () {
    base_self = this
    base_self.initValues()
  }
}

</script>

<style lang="scss" scoped>
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
        
    }
</style>